export default __webpack_public_path__ + "6527256d467a047cb775e86f466462e9.jpg";